import { createSelector } from "reselect";

export const selectUser = state => state.auth.user;
export const selectError = state => state.auth.error;
export const selectLoading = state => state.auth.loading;

export const selectToken = createSelector(
    [selectUser],
    user => user?.token
)